import React from 'react';
import clsx from 'clsx';
import { Document } from '@maiia/model/generated/model/api-patient/api-patient';
import DocumentThumbnail from '@/components/atoms/Document/DocumentThumbnail';

type Props = {
  isSelected?: boolean;
  document: Document;
  onClick?: React.ReactEventHandler;
};

const Card = ({ document, isSelected, onClick }: Props) => {
  const { name } = document;
  return (
    <div
      className={clsx('document-card', isSelected && 'selected')}
      onClick={onClick}
    >
      <div className="document-card__content">
        <DocumentThumbnail document={document} />
        <p className="name">{name}</p>
      </div>
    </div>
  );
};

export default Card;
